import { StackScreenProps } from "@react-navigation/stack";
import { ManageLlmStrategiesParamList } from "../../../../types";
import { Button, Page, Stack, Text } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { Colors, View } from "react-native-ui-lib";
import {
  useCurrentVendorProvider,
  useVendorControllerProvider,
} from "../../../../utilities/vendor";
import {
  ACCEPT_AI_TERMS_MUTATION,
  MUTATION_CREATE_LLM_STRATEGY,
} from "../../common";
import { useMutation } from "@apollo/client";

export interface AcceptAiTermsScreenProps
  extends StackScreenProps<
    ManageLlmStrategiesParamList,
    "AcceptAiTermsScreen"
  > {}

export const AcceptAiTermsScreen = ({
  navigation,
}: AcceptAiTermsScreenProps) => {
  const { t } = useTranslation("settings");

  const { currentVendor, dangerouslySetCurrentVendor } =
    useVendorControllerProvider();

  const [m] = useMutation<{
    acceptAiTerms: boolean;
  }>(ACCEPT_AI_TERMS_MUTATION);

  const handleOnAcceptTerms = async () => {
    if (!currentVendor) {
      return;
    }
    return m().then(async (result) => {
      if (result.data?.acceptAiTerms) {
        console.log("Accepted AI Terms");
        dangerouslySetCurrentVendor({
          ...currentVendor,
          aiTermsAccepted: true,
        });
        navigation.pop();
      }
    });
  };

  const handleOnDeclineTerms = () => {
    navigation.getParent()?.goBack(); // go back to settings root
  };

  const footerMarkup = (
    <View>
      <View marginB-20>
        <Text
          style={{
            fontSize: 20,
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Do you agree to these terms of use?
        </Text>
      </View>

      <View row>
        <View marginR-10 flex>
          <Button
            label={t("button.accept_ai_terms")}
            backgroundColor={Colors.action}
            color="white"
            onPress={handleOnAcceptTerms}
          ></Button>
        </View>
        <View flex>
          <Button
            label={t("button.decline_ai_terms")}
            isAction
            onPress={handleOnDeclineTerms}
          ></Button>
        </View>
      </View>
    </View>
  );

  return (
    <Page title={t("title.accept_ai_terms")} footer={footerMarkup}>
      <Stack vertical>
        <View>
          <Text {...commonTextProps}>
            Please note that the use of integrated AI services is entirely at
            your own risk. These services are provided by external entities and
            are not controlled by Tower Systems. Tower Systems disclaims any
            responsibility for the accuracy, reliability, or outcomes of
            responses generated by these AI services.
          </Text>
        </View>
        <View>
          <Text {...commonTextProps}>
            Additionally,{" "}
            <Text style={{ fontWeight: "bold", ...commonTextProps.style }}>
              you shall be responsible and liable for all uses of these services
              and any data that results from accessing such services, directly
              or indirectly
            </Text>
            , and Tower Systems assumes no liability for any data provided to or
            processed by these third-party AI services. By using this
            integration, you agree{" "}
            <Text style={{ fontWeight: "bold", ...commonTextProps.style }}>
              to indemnify, defend, and hold harmless Tower Systems from and
              against any claims, damages, losses or costs
            </Text>{" "}
            arising from your use of these services.
          </Text>
        </View>
        <View>
          <Text {...commonTextProps}>
            Furthermore, please be aware that, depending on your plan with your
            AI service, any data you share with your AI service may become part
            of its AI training and may therefore be available publicly.
          </Text>
        </View>
      </Stack>
    </Page>
  );
};

const commonTextProps = {
  style: {
    fontSize: 18,
  },
};
